// Workspace member roles
export type WorkspaceMemberRole = 'owner' | 'admin' | 'editor' | 'viewer';

// Workspace team member
export interface WorkspaceMember {
  id: string;
  workspaceId: string;
  userId: string;
  userName?: string;
  userEmail?: string;
  role: WorkspaceMemberRole;
  invitedBy?: string;
  joinedAt: string;
}

// Request to update a member's role
export interface UpdateMemberRoleRequest {
  role: WorkspaceMemberRole;
}
